export default __webpack_public_path__ + "static/DSM-25400b4cbbf108a31f3c007cad07d8e3.png";